import { Button } from '@/components/shared/button/Button';
import { TSTitleCard } from '@/components/shared/card/Card';
import { handleMutation } from '@/helpers/toastHelper';
import { ReadEmployee, useResetPasswordMutation } from '@/services/gql/graphql.generated';
import { strings } from '@/services/translation/strings';
import { FunctionComponent } from 'react';
import { AiOutlineExclamationCircle } from 'react-icons/ai';

interface TeamMemberActionCardProps {
  employee: ReadEmployee;
}

const actionStringPrefix = strings.timeshift.teamMember.actions;
const TeamMemberActionCard: FunctionComponent<TeamMemberActionCardProps> = ({ employee }) => {
  const [{ fetching }, send] = useResetPasswordMutation();

  const onResetClick = async () => {
    await handleMutation(() => send({ employeeId: employee.identityId }), {
      successMessage: actionStringPrefix.passwordReset.success,
      errorMessage: actionStringPrefix.passwordReset.error
    });
  };

  return (
    <TSTitleCard className="bg-white" title={actionStringPrefix.cardTitle} icon={AiOutlineExclamationCircle}>
      <div className="flex flex-row space-x-2">
        <div className="flex flex-row space-x-8">
          <div className="flex flex-col">
            <p className="text-lg font-semibold">{actionStringPrefix.passwordReset.label}</p>
            <p>{actionStringPrefix.passwordReset.description}</p>
          </div>
          <Button loading={fetching} primary onClick={onResetClick}>
            {actionStringPrefix.passwordReset.sendEmail}
          </Button>
        </div>
      </div>
    </TSTitleCard>
  );
};

export default TeamMemberActionCard;
